(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Paywall"] = factory();
	else
		root["Paywall"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialized = exports.VERSION = undefined;
	
	var _package = __webpack_require__(1);
	
	var _package2 = _interopRequireDefault(_package);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _window = window,
	    Voonto = _window.Voonto;
	
	
	Voonto.ready.then(function (app) {
	  Voonto.require('jquery').then(function ($) {
	    window.paywall = { $: $ };
	
	    __webpack_require__(2);
	  });
	});
	
	var VERSION = exports.VERSION = _package2.default.version;
	var initialized = exports.initialized = false;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = {"name":"paywall","version":"1.5.1","description":"Vocento Paywall","main":"src/index.js","scripts":{"start":"./node_modules/.bin/webpack-dev-server","build":"./node_modules/.bin/webpack","report":"plato -r -d report -l .jshintrc -t paywall src"},"author":"Iván Pérez <ivanperez@vocento.com>","license":"SEE LICENSE IN LICENSE.md","devDependencies":{"babel-core":"^6.17.0","babel-loader":"^6.2.5","babel-polyfill":"^6.16.0","babel-preset-es2015":"^6.16.0","case":"^1.4.2","chai":"^3.5.0","chalk":"^1.1.3","html-webpack-plugin":"^2.24.1","js-cookie":"^2.1.3","json-loader":"^0.5.4","mocha":"^3.1.0","mocha-loader":"^1.0.0","parse-url":"^1.3.5","webpack":"^1.13.2","webpack-dev-server":"^1.16.2","webpack-shell-plugin":"^0.4.3"}}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.initialized = undefined;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _paywallNotifier = __webpack_require__(4);
	
	var _paywallNotifier2 = _interopRequireDefault(_paywallNotifier);
	
	var _constants = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var app = Voonto.getInstance(); //import './scfp/scfp-min';
	//import './scfp/ev-sc.min';
	
	
	app.on(_constants.PAYWALL_CONTENT, function () {
	  var config = app.lookup(_constants.CONFIG_NAMESPACE);
	  // if (config.isNewAnonymousSession && config.isNewAnonymousSession !== 'false') {
	  // EV.Sc.init({authorizeUrl});
	  // EV.Sc.handleNewSession((result) => {
	  //   if (!navigator.cookieEnabled) {
	  //     $.extend(config, {
	  //       result: result.responseText,
	  //       meter:  result.getHeader('X-METER_NAME'),
	  //       pid:    result.getHeader('X-USER_ID'),
	  //       count:  result.getHeader('X-METER_COUNT'),
	  //       max:    result.getHeader('X-METER_MAX'),
	  //       viewed: result.getHeader('X-REPEAT_VIEW')
	  //     }, {
	  //       meterExceeded: result.getHeader('X-METER_EXCEEDED')
	  //     });
	  //   } else if (!result.allowAccess) {
	  //     // FIXME: in this case, scfp is saved and Evolok know it. No need to reload
	  //     let url = window.location.href.replace('http://','https://');
	  //     window.location.href = url;
	  //   }
	
	  //   _notify(app, config);
	  // }, (/*error*/) => {
	  //   throw Error('[Paywall] EV.Sc.handleNewSession error');
	  // }, config.cookie, true);
	  // } else {
	  // Paywall::Is NOT anonimous session
	  _notify(app, config);
	  // }
	});
	
	//init paywall
	if (app.lookup('vocento.config.paywall').enabled) {
	  app.trigger(_constants.PAYWALL_CONTENT);
	} else {
	  exports.initialized = initialized = true;
	}
	
	app.on('voonto:reload', function () /* event, element$ */{
	  app.trigger(_constants.PAYWALL_CONTENT);
	});
	
	var initialized = exports.initialized = false;
	
	/* private */
	
	function _notify(app, config) {
	  if (initialized) {
	    app.trigger(_constants.SET_EVENT, {
	      IDEvolok: config.pid,
	      productoEvolok: config.meter,
	      nPaginasConsumidas: config.count,
	      nPaginasPermitidas: config.max,
	      autorizacionContenido: config.result,
	      idCookieEvolok: config.cookie
	    });
	  }
	
	  exports.initialized = initialized = true;
	  app.promised(_constants.READY_PROMISE_NS, config);
	
	  // NOTE: If config.result !== '' mean the Media is Paywall On+
	  if (config.result && config.result.length) {
	    app.when(_constants.GIGYA_READY).then(function (authData) {
	      if (authData.getUserType() === 'anonimo') {
	        var userProducts = {};
	        _paywallNotifier2.default.init({ authData: authData, userProducts: userProducts, config: config, app: app });
	      } else {
	        app.when(_constants.GIGYA_PRODUCTS_READY).then(function (userProducts) {
	          _paywallNotifier2.default.init({ authData: authData, userProducts: userProducts, config: config, app: app });
	        });
	      }
	    });
	  }
	}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = window.paywall.$;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _paywallFactory = __webpack_require__(5);
	
	var _paywallFactory2 = _interopRequireDefault(_paywallFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Notifier = function () {
	  function Notifier() {
	    _classCallCheck(this, Notifier);
	  }
	
	  _createClass(Notifier, null, [{
	    key: 'init',
	    value: function init() {
	      // Crear los distintos de Alertas
	      this.alerts = _paywallFactory2.default.createAlerts.apply(_paywallFactory2.default, arguments);
	
	      // Ordenar las alertas por prioridad de ser ejecutadas
	      this.alerts.sort(function (a, b) {
	        return a.priority - b.priority;
	      });
	
	      for (var i = 0; i < this.alerts.length; i++) {
	        var alert = this.alerts[i];
	        if (alert.show() && alert.final === true) {
	          break;
	        }
	      }
	    }
	  }]);
	
	  return Notifier;
	}();
	
	exports.default = Notifier;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ALERT_TYPES = undefined;
	
	var _multiSession = __webpack_require__(6);
	
	var _multiSession2 = _interopRequireDefault(_multiSession);
	
	var _nLeftContent = __webpack_require__(9);
	
	var _nLeftContent2 = _interopRequireDefault(_nLeftContent);
	
	var _lastContent = __webpack_require__(10);
	
	var _lastContent2 = _interopRequireDefault(_lastContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ALERT_WALL_TYPES = '';
	var rtimWall = window.vocento.__PROVIDER__.paywall.rtimWall;
	if (rtimWall === true) {
	  ALERT_WALL_TYPES = {
	    'multi-session': _multiSession2.default
	  };
	} else {
	  ALERT_WALL_TYPES = {
	    'multi-session': _multiSession2.default,
	    'n-left-content': _nLeftContent2.default,
	    'last-content': _lastContent2.default
	  };
	}
	var ALERT_TYPES = exports.ALERT_TYPES = ALERT_WALL_TYPES;
	
	var Factory = Object.freeze({
	  createAlerts: function createAlerts() {
	    var _arguments = arguments;
	
	    return Object.keys(ALERT_TYPES).map(function (type) {
	      if (!ALERT_TYPES.hasOwnProperty(type)) {
	        throw Error('[Paywall] alert type not found');
	      }
	      return new (Function.prototype.bind.apply(ALERT_TYPES[type], [null].concat(Array.prototype.slice.call(_arguments))))();
	    });
	  }
	});
	
	exports.default = Factory;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _abstract = __webpack_require__(7);
	
	var _abstract2 = _interopRequireDefault(_abstract);
	
	var _constants = __webpack_require__(8);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONTAINER = '[data-voc-pw-concurrent-session]';
	
	var MultiSession = function (_Abstract) {
	  _inherits(MultiSession, _Abstract);
	
	  function MultiSession() {
	    var _ref;
	
	    _classCallCheck(this, MultiSession);
	
	    var _this = _possibleConstructorReturn(this, (_ref = MultiSession.__proto__ || Object.getPrototypeOf(MultiSession)).call.apply(_ref, [this, CONTAINER].concat(Array.prototype.slice.call(arguments))));
	
	    _this.priority = -4;
	    _this.final = true;
	    return _this;
	  }
	
	  _createClass(MultiSession, [{
	    key: 'show',
	    value: function show() {
	      var container$ = (0, _jquery2.default)(CONTAINER);
	
	      if (container$.length && container$.is(':visible') && this.concurrentSessionLimit()) {
	        container$.show();
	        _abstract2.default.canNotViewContent();
	        this._logout();
	      }
	    }
	  }, {
	    key: '_logout',
	    value: function _logout() {
	      Voonto.getInstance().when(_constants.GIGYA_READY).then(function (gigyaux) {
	        return gigyaux.logout({ reloadOnLogout: false });
	      });
	    }
	  }]);
	
	  return MultiSession;
	}(_abstract2.default);
	
	exports.default = MultiSession;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _constants = __webpack_require__(8);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Abstract = function () {
	  function Abstract(container, _ref) {
	    var config = _ref.config;
	
	    _classCallCheck(this, Abstract);
	
	    this.priority = 0;
	    this.final = false;
	    this.config = config;
	    this.container$ = (0, _jquery2.default)(_constants.VIDEO_PLAYER_CONTAINER).find(container).length ? (0, _jquery2.default)(_constants.VIDEO_PLAYER_CONTAINER).find(container) : (0, _jquery2.default)(container).eq(0);
	  }
	
	  _createClass(Abstract, [{
	    key: 'isViewed',
	    value: function isViewed() {
	      return this.config.viewed === 'true';
	    }
	  }, {
	    key: 'isMeterExceeded',
	    value: function isMeterExceeded() {
	      return this.config.meterExceeded && this.config.meterExceeded.length > 0;
	    }
	  }, {
	    key: 'isExtra',
	    value: function isExtra() {
	      return this.config.isExtra === 'true';
	    }
	  }, {
	    key: 'concurrentSessionLimit',
	    value: function concurrentSessionLimit() {
	      return ('' + this.config.concurrentSessionLimit).trim();
	    }
	  }, {
	    key: 'replaceContent',
	    value: function replaceContent(removeContent) {
	      if ((0, _jquery2.default)(_constants.VIDEO_PLAYER_MODAL_CONTAINER, _constants.VIDEO_PLAYER_CONTAINER).length) {
	        if (removeContent) {
	          (0, _jquery2.default)(_constants.VIDEO_PLAYER_CONTENT_TO_HIDE, _constants.VIDEO_PLAYER_CONTAINER).remove();
	        }
	        var pwContainer$ = (0, _jquery2.default)('<div class="wrapper"></div>');
	        (0, _jquery2.default)(_constants.VIDEO_PLAYER_MODAL_CONTAINER, _constants.VIDEO_PLAYER_CONTAINER).append(pwContainer$);
	        pwContainer$.append(this.container$);
	      } else {
	        if (removeContent) {
	          (0, _jquery2.default)(_constants.CONTENT_CONTAINER).html(this.container$);
	        } else {
	          (0, _jquery2.default)(_constants.CONTENT_CONTAINER).append(this.container$);
	        }
	      }
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      var _this = this;
	
	      (0, _jquery2.default)(_constants.CLOSE_BUTTON, this.container$).on('click', function (event) {
	        event.preventDefault();
	        _this.container$.hide();
	      });
	      this.replaceContent();
	      this.container$.show();
	    }
	  }], [{
	    key: 'canNotViewContent',
	    value: function canNotViewContent() {
	      (0, _jquery2.default)("div[data-voc-arrows-display]").remove();
	      (0, _jquery2.default)(".wrapper.voc-story").css({ "-webkit-user-select": "none", "-moz-user-select": "none", "-ms-user-select": "none", "user-select": "none" });
	      (0, _jquery2.default)("body").addClass('no-scroll');
	    }
	  }]);
	
	  return Abstract;
	}();
	
	exports.default = Abstract;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ALLOW_ACCESS = exports.ALLOW_ACCESS = 'ALLOW_ACCESS';
	var CLOSE_BUTTON = exports.CLOSE_BUTTON = '[data-voc-pw-close]';
	var CONFIG_NAMESPACE = exports.CONFIG_NAMESPACE = 'vocento.__PROVIDER__.paywall';
	var CONTENT_CONTAINER = exports.CONTENT_CONTAINER = '[data-voc-pw-layer]';
	var COOKIE_DOMAIN = exports.COOKIE_DOMAIN = '.' + window.__VOONTO__.lookup('vocento.site').tlddomain;
	var COOKIE_TRIAL_VIEWED_NAME = exports.COOKIE_TRIAL_VIEWED_NAME = 'trialViewed';
	var COOKIE_TRIAL_VIEWED_VALUE = exports.COOKIE_TRIAL_VIEWED_VALUE = 'alreadyViewed';
	var COOKIE_TRIAL_PRESCRIPTION = exports.COOKIE_TRIAL_PRESCRIPTION = 'voc_trial';
	var EVOLOK_SESSION_CHECK_PATH = exports.EVOLOK_SESSION_CHECK_PATH = '/ev_session_check/';
	var PAYWALL_CONTENT = exports.PAYWALL_CONTENT = 'paywall:content';
	var READY_PROMISE_NS = exports.READY_PROMISE_NS = 'paywall:ready';
	var SET_EVENT = exports.SET_EVENT = 'vtm:set';
	
	/* NOTE: VocUsers config */
	var ANONIMOUS_USER = exports.ANONIMOUS_USER = 'anonimo';
	var GIGYA_DATA_READY = exports.GIGYA_DATA_READY = 'vocuser:accountsondataready';
	var GIGYA_PRODUCTS_READY = exports.GIGYA_PRODUCTS_READY = 'vocuser:productsonready';
	var GIGYA_READY = exports.GIGYA_READY = 'vocuser:ready';
	var REGISTER_USER = exports.REGISTER_USER = 'registrado';
	var TRIAL_USER = exports.TRIAL_USER = 'trial';
	
	/* NOTE: Video-Player config */
	var VIDEO_PLAYER_CONTAINER = exports.VIDEO_PLAYER_CONTAINER = '#voc-video-player-modalcontainer';
	var VIDEO_PLAYER_CONTENT_TO_HIDE = exports.VIDEO_PLAYER_CONTENT_TO_HIDE = '[data-voc-pw-content-to-hide]';
	var VIDEO_PLAYER_MODAL_CONTAINER = exports.VIDEO_PLAYER_MODAL_CONTAINER = '.modal-content';

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _abstract = __webpack_require__(7);
	
	var _abstract2 = _interopRequireDefault(_abstract);
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONTAINER = '[data-voc-pw-news-left]',
	    ONE_NEWS_MSG = '[data-voc-pw-one-news]',
	    N_NEWS_MSG = '[data-voc-pw-n-news]',
	    REMAINING_NEWS = [3, 2, 1];
	
	var NLeftContent = function (_Abstract) {
	  _inherits(NLeftContent, _Abstract);
	
	  function NLeftContent() {
	    var _ref;
	
	    _classCallCheck(this, NLeftContent);
	
	    var _this = _possibleConstructorReturn(this, (_ref = NLeftContent.__proto__ || Object.getPrototypeOf(NLeftContent)).call.apply(_ref, [this, CONTAINER].concat(Array.prototype.slice.call(arguments))));
	
	    _this.priority = -1;
	    _this.final = true;
	    return _this;
	  }
	
	  _createClass(NLeftContent, [{
	    key: 'show',
	    value: function show() {
	      var maxValue = parseInt(this.config.max),
	          countValue = parseInt(this.config.count);
	      var isExtra = this.config.isExtra === 'true';
	      var isViewed = this.config.viewed === 'true';
	      var remainingValue = maxValue - countValue,
	          steps = this._getDaysToAlert();
	
	      if (countValue > 0 && remainingValue > 0 && !isExtra && steps.indexOf(remainingValue) !== -1 && !isViewed) {
	        if (remainingValue > 1) {
	          (0, _jquery2.default)(N_NEWS_MSG, this.container$).find("span:first").html(remainingValue);
	          (0, _jquery2.default)(N_NEWS_MSG, this.container$).show();
	        } else {
	          (0, _jquery2.default)(ONE_NEWS_MSG, this.container$).show();
	        }
	
	        _get(NLeftContent.prototype.__proto__ || Object.getPrototypeOf(NLeftContent.prototype), 'show', this).call(this);
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: '_getDaysToAlert',
	    value: function _getDaysToAlert() {
	      if (this.config.daysToAlertSteps) {
	        try {
	          var parseValues = JSON.parse(this.config.daysToAlertSteps);
	
	          if (parseValues.default === true) {
	            return REMAINING_NEWS;
	          }
	
	          return Object.keys(parseValues).map(function (item) {
	            return parseInt(item);
	          });
	        } catch (e) {
	          return [];
	        }
	      }
	
	      return REMAINING_NEWS;
	    }
	  }]);
	
	  return NLeftContent;
	}(_abstract2.default);
	
	exports.default = NLeftContent;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _abstract = __webpack_require__(7);
	
	var _abstract2 = _interopRequireDefault(_abstract);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CONTAINER = '[data-voc-pw-last-news]';
	
	var LastContent = function (_Abstract) {
	  _inherits(LastContent, _Abstract);
	
	  function LastContent() {
	    var _ref;
	
	    _classCallCheck(this, LastContent);
	
	    var _this = _possibleConstructorReturn(this, (_ref = LastContent.__proto__ || Object.getPrototypeOf(LastContent)).call.apply(_ref, [this, CONTAINER].concat(Array.prototype.slice.call(arguments))));
	
	    _this.priority = 0;
	    _this.final = true;
	    return _this;
	  }
	
	  _createClass(LastContent, [{
	    key: 'show',
	    value: function show() {
	      var maxValue = parseInt(this.config.max),
	          countValue = parseInt(this.config.count);
	      var leftValue = maxValue - countValue;
	
	      if (this.config.isExtra === 'false' && !this.isViewed() && leftValue === 0 && !this.isMeterExceeded()) {
	        _get(LastContent.prototype.__proto__ || Object.getPrototypeOf(LastContent.prototype), 'show', this).call(this);
	        return true;
	      }
	
	      return false;
	    }
	  }]);
	
	  return LastContent;
	}(_abstract2.default);
	
	exports.default = LastContent;

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// paywall.js